import React, { useCallback, useState } from "react"

import { Link } from "gatsby"
import LanguageSwitch from "@components/LanguageSwitch"
import SVGHeader from "@components/SVGHeader"
import EuropeUnionImage from "@images/europe.png"
import Linkedin from "@images/linkedinLong.svg"

import { useTranslation } from "gatsby-plugin-react-i18next"
import { useURLforArray } from "@hooks/siteURLs"
import { openLinkedin, linkedinHref } from "@utils/navigation"
import { useHubspotForm } from "@hooks/useHubspotForm"
import { useBreakpoints } from "@hooks/useBreakpoints"

const classNameListElement = `
  text-sm xl:text-[20px] 
  leading-6 xl:leading-[34px] 
  font-normal font-inter text-bcoral
  block py-3 md:py-0
`

const OpeningHour = () => {
  const { t } = useTranslation()
  const { isMobile } = useBreakpoints()
  return (
    <div className="px-2 mb-10 md:mb-0 desk:px-2.5 fhd:px-4 basis-full md:basis-2/6 desk:basis-1/4">
      {/* <h6 className="text-tiny fhd:text-base uppercase font-bold font-inter text-dblue mb-3 desk:font-semibold">
        {t("Footer_Opening_hours_title")}
      </h6> */}
      {/* <p className={classNameListElement}>
        {t("Footer_Opening_hours_monday_thursday")}
      </p> */}
      {/* <p className={classNameListElement}>{t("Footer_Opening_hours_friday")}</p> */}
      <ul className="flex -mx-1.25 my-4">
        {isMobile && (
          <li className="inline-flex items-center pl-1.25 w-full">
            <button onClick={openLinkedin}>
              <img alt="Linkedin" src={Linkedin} />
            </button>
            <div className="left-auto absolute right-6">
              <LanguageSwitch />
            </div>
          </li>
        )}
        {!isMobile && (
          <li className="px-1.25">
            <a href={linkedinHref} target="_blank">
              <img alt="Linkedin" src={Linkedin} />
            </a>
          </li>
        )}
      </ul>
      {!isMobile && <LanguageSwitch />}
      <figure className="mt-7.5 mb-2">
        <img alt="img" src={EuropeUnionImage} className="object-cover h-10" />
      </figure>
      <p className="text-tiny font-normal font-inter text-g82">
        {t("Footer_Horizon2020")}
      </p>
    </div>
  )
}

const GeneralInfo = ({ links }) => {
  const { t } = useTranslation()
  return (
    <div className="px-2 mb-10 md:mb-7 desk:mb-0 desk:px-2.5 fhd:px-4 basis-full md:basis-full desk:basis-1/2">
      <p className="text-tiny fhd:text-base uppercase font-bold font-inter text-dblue mb-3 desk:font-semibold">
        {t("Footer_GeneralInfo")}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-1 xl:grid-cols-1">
        <ul className="flex flex-col md:block p-0 m-0">
          <li className="-my-3 md:my-0">
            <Link
              to={links["contact-us"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Contact_us")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["about-us"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Menu-bar_About_Us")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["about-us/impact"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Menu-bar_Impact")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["scrap-metal-price"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Scrap_Prices")}
            </Link>
          </li>
        </ul>
        <ul className="flex flex-col md:block p-0 m-0">
          <li className="-my-3 md:my-0">
            <Link
              to={links["datahub"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Datahub")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["site-map"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Sitemap")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

const TermsAndCondition = ({ links }) => {
  const { t } = useTranslation()

  const handlePrivacySettingsClick = event => {
    event.preventDefault()
    window.UC_UI && window.UC_UI.showSecondLayer()
  }

  return (
    <div className="px-2 mb-10 md:mb-0 desk:mt-0 desk:px-2.5 fhd:px-4 basis-full md:basis-full desk:basis-1/2">
      <p className="text-tiny fhd:text-base uppercase font-bold font-inter text-dblue mb-3 desk:font-semibold">
        {t("Footer_Terms-and-conditions")}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-1 xl:grid-cols-1">
        <ul className="flex flex-col md:block p-0 m-0">
          <li className="-my-3 md:my-0">
            <Link
              to={links["privacy-policy"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Privacy")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["terms-and-conditions"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Terms-of-service")}
            </Link>
          </li>
          <li className="-my-3 md:my-0">
            {" "}
            <a
              className={classNameListElement}
              href="#"
              onClick={handlePrivacySettingsClick}
            >
              {t("Footer_Cookies_Policy")}
            </a>
          </li>
          <li className="-my-3 md:my-0">
            <Link
              to={links["disclaimer"]}
              className={classNameListElement}
              activeClassName="text-mgreen font-medium"
            >
              {t("Footer_Disclaimer")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  )
}

const NewsLetter = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const [isSubmitted, setIsSubmitted] = useState(false)

  useHubspotForm({
    portalId: "25964422",
    formId: "7d2c8bd0-691b-4a45-a7f0-bd68fdf47c9a",
    target: "#hubspotFormFooter",
    locale: language,
    groupErrors: false,
    onSubmitted: () => {
      setIsSubmitted(true)
    },
    translations: {
      [language]: {
        submitText: t("Contact_Button_Send"),
        fieldLabels: {
          firstname: t("Contact_FirstName"),
          lastname: t("Contact_LastName"),
          email: t("Contact_Email"),
        },
      },
    },
  })

  return (
    <div className="px-2 desk:px-2.5 fhd:px-4 basis-full md:basis-2/6 desk:basis-5/12">
      <div className="desk:pl-20 xl:pl-25 fhd:pl-36">
        <p className="text-tiny fhd:text-base uppercase font-bold font-inter text-dblue mb-3 desk:font-semibold">
          {t("Footer_NL_signup")}
        </p>

        <div
          className={`  
            ${isSubmitted ? "hidden" : ""} `}
          id="hubspotFormFooter"
        ></div>
        <div
          className={`  
            ${!isSubmitted ? "hidden" : ""}    
          `}
        >
          {" "}
          <p
            className={`
              `}
          >
            {t("Newsletter_ThankyouBody")}
          </p>
        </div>
      </div>
    </div>
  )
}

const FooterBase = () => (
  <div className="px-6 py-7.5 xl:px-12.5 xl:py-9 shadow-[0_-0.5px_0_rgba(21,17,36,0.2)]">
    <div
      className={`mx-auto
      desk:px-25
      max-w-screen-fhd`}
    >
      <p className="text-tiny uppercase font-bold font-inter text-g82 desk:text-[16px] desk:font-medium desk:leading-[140%]">
        &copy; {new Date().getFullYear()} Schrott24
      </p>
    </div>
  </div>
)

const FooterModule = () => {
  // All the links in the footer
  const allLinks = [
    "contact-us",
    "about-us",
    "about-us/impact",
    "scrap-metal-price",
    "datahub",
    "site-map",
    "privacy-policy",
    "terms-and-conditions",
    "cookies",
    "disclaimer",
  ]

  const links = useURLforArray(allLinks)

  return (
    <footer className="mx-auto bg-white">
      <div className="bg-dblue w-full pb-5   px-6 pt-5 xl:px-[50px] xl:pt-[25px] xl:pb-[25px] ">
        <SVGHeader text="Metaloop" />
      </div>
      <div className="mx-auto px-6 py-6 md:px-11 md:py-10 xl:p-25 fhd:py-20 fhd:px-25 max-w-screen-fhd">
        <div className="flex flex-wrap -mx-2 md:-mx-2 desk:-mx-2.5 fhd:-mx-4">
          <OpeningHour />
          <div className="px-2 desk:px-2.5 fhd:px-4 basis-full md:basis-2/6 desk:basis-2/6">
            <div className="flex flex-wrap -mx-2 md:-mx-2 desk:-mx-2.5 fhd:-mx-4">
              <GeneralInfo links={links} />
              <TermsAndCondition links={links} />
            </div>
          </div>
          <NewsLetter />
        </div>
      </div>
      <FooterBase />

      <noscript>
        <img
          src="https://www.innovative-astute.com/798238.png"
          style={{ display: "none" }}
        />
      </noscript>
    </footer>
  )
}

export default FooterModule
